'use strict';
import "angular-ui-bootstrap";

import {EwSiteApp} from '../../app/ewsiteapp';

EwSiteApp.requires.push('ui.bootstrap');

EwSiteApp.controller('VsdtcalendarCtrl', ["$scope", "$log", function($scope, $log){
	$scope.current_month = "";
	$scope.calendar_days = {};
	$scope.available_dates = [];
	$scope.calendarEvent = calendarEvent;
	$scope.min_date = new Date($scope.calendarEvent.calendar.min);
	$scope.events = [];
	$scope.recent_events = [];
	$scope.show = true;
	
	$scope.options = {
		maxMode: 'day',
		datepickerMode: 'day',
		showWeeks: false,
		dateDisabled: disabledDates,
		formatDay: 'd',
		minDate: new Date($scope.calendarEvent.calendar.min),
		maxDate: new Date($scope.calendarEvent.calendar.max)
	};
	
	$scope.format = 'yyyy-MM-dd';
	$scope.date = new Date($scope.calendarEvent.calendar.selected);
	
	function disabledDates(data){
		var day=data.date.getDate();
		var month=data.date.getMonth()+1;
		var year=data.date.getFullYear();
		var fullDate=year+'-'+month+'-'+day;
		var dates=$scope.available_dates;
		if (data.mode === 'day' && ( dates.indexOf(fullDate)==-1 )) {
			return true;
		}
		return false; 
	};
	
	$scope.getMonthData = function(){
		if($scope.calendarEvent.shows.length > 0){
			for(var i=0;i<$scope.calendarEvent.shows.length;i++){
				var data = $scope.calendarEvent.shows[i];
				var key = "d"+data.date_time.m+"_"+data.date_time.d;
				if(!$scope.calendar_days[key]){
					$scope.calendar_days[key] = {selected: false, list: []};
				}
				$scope.calendar_days[key].list.push(data);
				$scope.available_dates.push(data.date_time.full);
			}
			
			$scope.select($scope.date);
		}else{
			$scope.show = false;
		}
	};
	
	$scope.select = function(date){
		if(!date){
			var date = $scope.date;
		}
		$scope.events = $scope.calendar_days["d"+(date.getMonth()+1)+"_"+date.getDate()].list;
		$scope.setRecentEvent(date);
	};
	
	$scope.setRecentEvent = function(disabledDay){
		var shows = $scope.calendarEvent.shows;
		$scope.recent_events = [];	
		var day=disabledDay.getDate();
		var month=disabledDay.getMonth()+1;
		var year=disabledDay.getFullYear();
		
		var key = year+"-"+month+"-"+day;
		if(shows.length > 0){
			for(var i=0;i<shows.length;i++){
				if(shows[i].date_time.full !== key && $scope.recent_events.length < $scope.calendarEvent.list_limit){
					$scope.recent_events.push(shows[i]);
				}
			}
		}
		$scope.current_month = months[$scope.date.getMonth()];
		
		setTimeout(function(){
			$('.equalheight').responsiveEqualHeightGrid();
			$('.equalheight2').responsiveEqualHeightGrid();
		}, 100);
	};
	
	$scope.checkTicketDisplay = function(display){
		if (typeof(display) !== "undefined" && display === "1") {
			return true;
		}
		return false;
	};
	$scope.checkTicketStatus = function(status, expec){
		if (expec === status) {
			return true;
		}
		return false;
	};
	$scope.checkTicketTarget = function(status){
		if (status === "buynow" || status === "standing") {
			return true;
		}
		return false;
	};
	$scope.checkTicketHref = function(status){
		if (status === "soldout" || status === "free" || status === "canceled") {
			return true;
		}
		return false;
	};
	
	$scope.getMonthData();
//	$scope.setRecentEvent($scope.date);
	
}]).config(["$compileProvider", function($compileProvider){
	$compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|javascript):/);
}]);
